import { render, staticRenderFns } from "./Sendsecretcodes.vue?vue&type=template&id=1d4ad756"
import script from "./Sendsecretcodes.vue?vue&type=script&lang=js"
export * from "./Sendsecretcodes.vue?vue&type=script&lang=js"
import style0 from "./Sendsecretcodes.vue?vue&type=style&index=0&id=1d4ad756&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports